import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const FieldQtyWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const FieldQtyButton = styled.button`
  ${Reset('button')}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.color.primaryLight};
  width: 2.75rem;
  height: 2.75rem;

  ${props =>
    props.theme.contrastMode &&
    css`
      background: transparent;
      border: 1px solid ${props => props.theme.color.global};
      color: ${props => props.theme.color.global};
    `};

  svg {
    width: 50%;
    display: block;
    stroke: currentColor;
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`

export const FieldQtyInput = styled.input`
  ${Reset('all')}
  appearance: none;
  width: 2.75rem;
  height: 2.75rem;
  margin: 0 0.25rem;
  font-size: 1.2rem;
  text-align: center;
  background: transparent;

  &:focus {
    box-shadow: none;
    outline: 0;
  }
`
